module.exports = __webpack_public_path__ + "static/img/2.45110a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/zh/2.png
// module id = /osI
// module chunks = 0